import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, limit as firestoreLimit } from 'firebase/firestore';
import './main.css';

// ** Receive discount prop (already was) **
const Trending = ({ discount = 0, maxItems = 6 }) => {
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendingProducts = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const productsRef = collection(db, 'products');
        const q = query(
            productsRef,
            where('isTrending', '==', true),
            firestoreLimit(maxItems)
        );

        const querySnapshot = await getDocs(q);
        const productsData = querySnapshot.docs.map(doc => ({
          id: doc.id, // Use Firestore doc ID for key and potentially link ID
          ...doc.data(),
        }));
        setTrendingProducts(productsData);
      } catch (err) {
        console.error('Error fetching trending products:', err);
        setError('Could not load trending products.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchTrendingProducts();
  }, [maxItems]);

  // Use the passed discount prop
  const numericDiscount = Number(discount) || 0;

  return (
    <section className="products trending-section" id="trending">
      <h1 className="heading">Trending This<span> Week</span></h1>
      {isLoading && <p className="loading-message">Loading trending items...</p>}
      {error && <p className="error-message">{error}</p>}
      {!isLoading && !error && (
        <>
          {trendingProducts.length > 0 ? (
            <div className="box-container">
              {trendingProducts.map(product => {
                const sellingPrice = Number(product.Rate) || 0;
                const discountedSellingPrice = (sellingPrice * (1 - numericDiscount / 100)).toFixed(2);
                const displayPrice = numericDiscount > 0 ? discountedSellingPrice : sellingPrice.toFixed(2);
                const originalPrice = sellingPrice.toFixed(2);

                // Use Firestore doc ID for key
                return (
                  <div className="box" key={product.id}>
                    {numericDiscount > 0 && <span className="discount">-{numericDiscount}%</span>}
                    <div className="image">
                      {/* ... img tag ... */}
                       <img src={product.image || './sample.svg'} alt={product["Product name"]} onError={(e) => { /* ... */ }} />
                      <div className="icons">
                        {/* ... icons ... */}
                         <Link target='_blank' rel="noopener noreferrer" to={`https://wa.me/919911192881?text=...${product.SKU}`} className="fas fa-bag-shopping" title="Request Sample"></Link>
                         {/* ** Update Link - remove discount, use ID ** */}
                         <Link to={`/products/${product.id}`} className="cart-btn" title="View Product">View Product</Link>
                         <Link to="#" className="fas fa-share" title="Share Product" onClick={(e) => {
                             e.preventDefault();
                             // ** Update URL generation **
                             const productUrl = `${window.location.origin}/products/${product.id}`;
                             const shareText = `... ${productUrl}`;
                             navigator.clipboard.writeText(shareText).then(() => alert('Link copied!')).catch(err => console.error('Failed to copy: ', err));
                         }}></Link>
                      </div>
                    </div>
                    <div className="content">
                       {/* ... content ... */}
                       <h3>{product["Product name"]}</h3>
                       <p className='des'>SKU: {product.SKU || 'N/A'}</p>
                       <p className='des'> L:{product.L ?? '?'} H:{product.H ?? '?'} B:{product.B ?? '?'} (In) </p>
                       <div className="raw">Raw foam prices</div>
                       <div className="price">
                         ₹{displayPrice}
                         {numericDiscount > 0 && <span>₹{originalPrice}</span>}
                       </div>
                       {/* ** Update Link ** */}
                       <Link to={`/products/${product.id}`} className="btn"> View Details </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="no-products-message">No trending products featured right now.</p>
          )}
          {/* ** Update Link ** */}
          <Link to={`/products`} className="btn view-all-btn"> View all products </Link>
        </>
      )}
    </section>
  );
};

export default Trending;